import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { BasicFile } from '../../models/basic-file.model';
import { UtilityFunctions } from '../../utilities/functions.models';

@Component({
  standalone: false,
  selector: 'bt-img-preview',
  templateUrl: './img-preview.component.html',
  styleUrls: ['./img-preview.component.scss'],
 
})
export class ImgPreviewComponent implements OnInit {

  @Input() public file: BasicFile;

  @Output() public closed = new EventEmitter<any>();

  private originW: number;
  public imgW: number;
  public imgH: number;
  public zoomPerc: number = null;
  public show: boolean;
  public imgId = UtilityFunctions.newGuid();

  private zoomTimeout: any;
  private validFileExtensions = ['jpg', 'jpeg', 'png'];

  public ngOnInit(): void {
    if (this.file) this.manageFile();
  }

  public onClose() {
    this.closed.emit();
  }

  public onDownload() {
    window.open(this.file.FilePath, '_blank');
  }

  public onZoom(scrollEvent: any) {
    scrollEvent.stopPropagation();
    scrollEvent.preventDefault();
    if (scrollEvent.deltaY < 0 || (this.imgH > 75 && this.imgW > 75)) {
      this.imgH += (-scrollEvent.deltaY);
      this.imgW += (-scrollEvent.deltaY);
      this.showPerc();
    }
  }

  private manageFile() {
    const nameArray = this.file.FilePath ? this.file.FilePath.split('.') : [];
    const extension = nameArray.length ? nameArray[nameArray.length - 1] : null;
    this.show = !!extension && this.validFileExtensions.some(x => x === extension.toLowerCase());
    setTimeout(() => {
      const el = document.getElementById(this.imgId);
      if (el) {
        this.originW = !el.clientWidth ? 100 : el.clientWidth;
        this.imgH = !el.clientHeight ? 100 : el.clientHeight;
        this.imgW = !el.clientWidth ? 100 : el.clientWidth;
        this.showPerc();
      }
    });
  }

  private showPerc() {
    this.zoomPerc = +(this.imgW * 100 / this.originW).toFixed(2);
    clearTimeout(this.zoomTimeout);
    this.zoomTimeout = setTimeout(() => {
      this.zoomPerc = null;
    }, 1500);
  }
}
